import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<section id=\"home\" class=\"h40 d-flex align-items-center bg-about section-padding mt-5 mt-md-0\"><div class=\"container\"><div class=\"row justify-content-center text-center\"><div class=\"col-sm-12 col-lg-10\"><h1 class=\"title h1 text-shadow text-blue\">Quiénes somos</h1></div></div></div></section>", 1)
const _hoisted_2 = { id: "about" }
const _hoisted_3 = { class: "d-flex align-items-center py-5" }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "text-justify px-3" }
const _hoisted_8 = { class: "text-white text-bold py-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "text-white" }, " Somos una compañía 100% Mexicana, que ayuda a las personas a encontrar los cursos, talleres, carreras, diplomados, o cualquier servicio o producto educativo perfectos para su perfil. ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "text-white" }, " Somos una compañía preocupada por el bienestar de los mexicanos, y buscamos que la educación en el país sea adecuada para cada uno de nosotros. ", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("h5", _hoisted_8, _toDisplayString(_ctx.name), 1),
                _hoisted_9,
                _hoisted_10,
                _hoisted_11,
                _hoisted_12
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}